<template>
    <div class="my-3 promotion-card">
        <img
            :src="promotion.image"
            alt="Promotion Image"
            class="promotion-image"
        >
        <div class="px-3 py-2 d-flex justify-content-between">
            <h3 class="my-auto text-white">
                {{ promotion.name }}
            </h3>
            <button
                class="btn main-btn"
                @click="openOverlay = true"
            >{{ $t('detail') }}</button>
        </div>

        <van-overlay
            :show="openOverlay"
            @click="openOverlay = false"
        >
            <div
                class="wrapper col-lg-4 col-md-12 mx-auto d-flex h-100vh"
                @click.stop
            >
                <div
                    class="mx-auto my-auto p-4"
                    style="background: #161616 !important; border-radius: 7px;"
                >

                    <h2
                        class="pb-3"
                        style="color: #fff"
                    > {{ promotion.name }}</h2>
                    <span
                        style="color: #fff"
                        v-html="promotion.description"
                    ></span>
                    <div class="row m-0 mb-1 text-white">
                        <div class="col-6 p-0">Daily Usage Limit</div>
                        <div class="col-2">:</div>
                        <div class="col-4 p-0">{{ promotion.daily_usage_limit ?? 'Unlimited' }}</div>
                    </div>
                    <div class="row m-0 mb-1 text-white">
                        <div class="col-6 p-0">Bonus Percent</div>
                        <div class="col-2">:</div>
                        <div class="col-4 p-0">{{ promotion.promotion_percent ?? '-' }} %</div>
                    </div>
                    <div class="row m-0 mb-1 text-white">
                        <div class="col-6 p-0">Minimum Turn Over Amount</div>
                        <div class="col-2">:</div>
                        <div class="col-4 p-0">{{ promotion.minimum_turn_over_amount ?? '-' }}</div>
                    </div>
                    <div class="row m-0 mb-1 text-white">
                        <div class="col-6 p-0">Minimum Withdraw Times</div>
                        <div class="col-2">:</div>
                        <div class="col-4 p-0">{{ promotion.minimum_withdraw_times ?? '-' }}</div>
                    </div>

                    <div class="mt-3 d-flex flex-column">

                        <button
                            class="btn btn-primary btn-block w-25 mx-auto text-uppercase text-dark"
                            style="background: linear-gradient(135deg, #CFA757, #FAE68D, #DBB866) !important; color: #202020; border-radius: 20px; width: 6.5rem; box-shadow: none;"
                            @click="openOverlay = false"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
export default {
    props: {
        promotion: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            openOverlay: false
        }
    },
    methods: {
    }
}
</script>

<style scoped>
.promotion-card {
    position: relative;
    background-color: #202124;
    border-radius: 10px;
    overflow: hidden;
    transition: 0.3s ease;

    &.claimed {

        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: repeating-linear-gradient(45deg,
                    rgba(255, 255, 255, 0.05),
                    rgba(255, 255, 255, 0.05) 10px,
                    rgba(0, 0, 0, 0.05) 10px,
                    rgba(0, 0, 0, 0.05) 20px);
            background-color: rgba(0, 0, 0, 0.3);
            z-index: 1;
        }

        .claimed-logo {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 2;
        }
    }
}


.promotion-image {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    width: 100%;
    max-height: 150px;
    object-fit: cover;
}
</style>